import React, {FC} from 'react';
import {provider, useInstance} from 'react-ioc';
import {BrowserRouter as Router, Navigate, Route, Routes,} from 'react-router-dom';
import {YMInitializer} from 'react-yandex-metrika';
import {ApolloClient, ApolloProvider} from '@apollo/client';
import {ConfigProvider, theme} from 'antd';
import ru_RU from 'antd/locale/ru_RU';
import {observer} from 'mobx-react-lite';

import 'dayjs/locale/ru';

import ScrollToTop from '../components/common/ScrollToTop';
import Layout from '../components/Layout/Layout';
import {
    CART,
    CATEGORY, COLLECTION,
    CONTACT, DELIVERY,
    INDEX, ORDER, PAYMENT_CHECK, PRODUCT, ROOT, SUCCESS,
} from '../config/routes';
import ApolloClientDI from '../model/graphql/ApolloClientDI';
import {Store} from '../model/store/Store';
import StoreDI from '../model/store/StoreDI';
import {Category} from '../pages/Catalog/Category/Category';
import {Collection} from '../pages/Catalog/Category/Collection';
import {Product} from '../pages/Catalog/Product/Product';
import {Contacts} from '../pages/Contacts/Contacts';
import {Delivery} from '../pages/Delivery/Delivery';
import {Index} from '../pages/Index/Index';
import {Cart} from '../pages/Order/Cart';
import {Order} from '../pages/Order/Order';
import {PaymentCheck} from '../pages/Order/PaymentCheck';
import {Success} from '../pages/Order/Success';
import {Metrika} from '../shared/helpers/Metrika';

import './App.scss';

const App: FC = () => {

    const apolloClient = useInstance(ApolloClient);
    const {hydrated} = useInstance(Store)

    if (!hydrated) {
        return (
            <div>Loading...</div>
        );
    }

    return (
        <ConfigProvider locale={ru_RU} theme={{
            token: {
                colorPrimary: '#E08E79',
                colorText: '#000000',
                fontFamily: '\'Lora\', serif',
                fontSize: 16,
                controlHeight: 40,
                borderRadius: 0,
            },
            algorithm: theme.defaultAlgorithm

        }}>
            <ApolloProvider client={apolloClient}>
                <Router>
                    <ScrollToTop/>
                    <YMInitializer accounts={[104267323]}/>
                    <Metrika/>

                    <Routes>
                        <Route path={ROOT} element={<Layout/>}>
                            <Route path={INDEX} element={<Index/>}/>
                            <Route path={CONTACT} element={<Contacts/>}/>
                            <Route path={DELIVERY} element={<Delivery/>}/>

                            <Route path={CATEGORY} element={<Category/>}/>
                            <Route path={COLLECTION} element={<Collection/>}/>
                            <Route path={PRODUCT} element={<Product/>}/>
                            <Route path={CART} element={<Cart/>}/>
                            <Route path={ORDER} element={<Order/>}/>
                            <Route path={PAYMENT_CHECK} element={<PaymentCheck/>}/>
                            <Route path={SUCCESS} element={<Success/>}/>

                            <Route path="*" element={<Navigate to={INDEX}/>}/>
                        </Route>
                    </Routes>

                </Router>
            </ApolloProvider>
        </ConfigProvider>
    );
};

export default provider(
    StoreDI(),
    ApolloClientDI(),
)(observer(App));
